import React from 'react';
import { useTranslation } from 'react-i18next';
import OkrComment from '../../okr_comment/okr-comment';
import OkrMetric from './okr_metric';
import { OkrPopUp } from '../../types/okrpopup.types';
import OkrNotes from './okr_container/okr-notes';
import OkrWorkstream from './okr_container/okr-workstream';
import OkrReview from './okr_container/okr-review';
import OKRHistoryComp from './okr_container/okr-history';
import OkrAlignment from './okr_container/okr-alignment';
import CustomField from '../../../components/custom_fields/common/okr-customField';
import Okrstrategy from './okr_container/Okrstrategy';
import ObjectiveRelationships from '../../../components/ObjectiveRelationships';
import OkrFinancials from './okr_container/okr-financials';

const OkrContainer = ({ OkrActiveTab, goalId, ...rest }: OkrPopUp) => {
    const { t } = useTranslation();
    const isFinancialsEnabled =
        typeof window !== 'undefined'
        && (window as { wbConfig?: { isFinancialsEnabled?: boolean } }).wbConfig?.isFinancialsEnabled;
    return (
        <>
        <div
            aria-labelledby={`okrActiveTab-${OkrActiveTab == `${t('Key Results')}` ? 'key-results' : OkrActiveTab}`}
            className="goal-details-sub-header-details"
            id={`active-tab-${OkrActiveTab == `${t('Key Results')}` ? 'key-results' : OkrActiveTab}`}
            role="tabpanel"
        >
            {
                (OkrActiveTab == `${t('Key Results')}` || OkrActiveTab == `${t('OKRs')}`)
                && <OkrMetric goalId={goalId} {...rest} />
            }
            {
                OkrActiveTab == t('Custom Fields')
                && <CustomField objId={goalId} objTyp={5} {...rest} padding='27px' />
            }
            {
                OkrActiveTab == t('Comments')
                && <OkrComment goalId={goalId} {...rest} />
            }
            {
                OkrActiveTab == t('Notes')
                && <OkrNotes goalId={goalId} {...rest} />
            }
            {
                OkrActiveTab == t('Workstreams')
                && <OkrWorkstream goalId={goalId} {...rest} />
            }
            {
                OkrActiveTab == t('Reviews')
                && <OkrReview goalId={goalId} {...rest} />
            }

            {
                OkrActiveTab == t('History')
                && <OKRHistoryComp
                    goalId={goalId}
                    showSearchBox={false}
                    headers={['picture', 'description', 'date']}
                    maxPageSize={30}
                    perPageItem={10}
                    url=""
                    {...rest}
                />
            }
            {
                OkrActiveTab == t('Aligns')
                && <OkrAlignment
                    goalId={goalId}
                    key={`goal_aligns_${goalId}`}
                    wrapperClass="wb-ghead-alignspopup-wrapper wb-ghead-alignspopup-wrapper-scrolbar"
                    filterValue="5"
                    showTitle={false}
                    showHeader={false}
                    {...rest}
                />
            }
            {
                OkrActiveTab == 'Strategy'
                && <Okrstrategy goalId={goalId}  {...rest}/>
            }
            {
                OkrActiveTab == 'Relationships'
                && <ObjectiveRelationships objectiveId={goalId} canEdit={!!rest.goalData?.goals?.canEditGoal} />
            }
            {
                OkrActiveTab == t('Financials') && isFinancialsEnabled
                && <OkrFinancials goalId={goalId} {...rest} />
            }
        </div>
        </>
    )
}

export default OkrContainer;
